import crud from "../../../crud";

crud.conf['w-checkbox'] = {
    inline: true,
    domainValues: {},
    domainValuesOrder: [],
    value: []
}

const wCheckboxMixin = {

}
export default wCheckboxMixin
